import setLocationContainerData from './location-container-data';
import buildSpotsList from './spots-list';
import buildCollapsedSpotsList from './spots-list-collapsed';
import calculateDistanceLngLat from './calculate-distance-lnglat';
import buildCategoryFiltering from './category-filter';
import activateGoogleSearchApi from './google-search-api';
import setRouteDirection from './route-directions';
import setMarkersFilteringOn from './markers-filter';

function smoothZoomMap(map, currentZoom, targetZoom) {
  if (targetZoom > currentZoom) {
    setTimeout(() => {
      map.setZoom(targetZoom);
    }, 80);
  }
}

function reduceSpots(arr, fiedName, niveau) {
  return arr.reduce((newArr, item) => {
    item.Categories.filter(x => x.startsWith(niveau)).forEach(cat_ => {
      const cat = cat_.trim();
      const catIndex = newArr.findIndex(x => x.categoryId === cat);
      if (catIndex === -1) {
        newArr.push({ categoryId: cat, category: cat, [fiedName]: [item] });
      } else {
        newArr[catIndex][fiedName].push(item);
      }
    });
    return newArr;
  }, []);
}

export {
  activateGoogleSearchApi,
  buildCategoryFiltering,
  buildSpotsList,
  buildCollapsedSpotsList,
  calculateDistanceLngLat,
  reduceSpots,
  setLocationContainerData,
  setMarkersFilteringOn,
  setRouteDirection,
  smoothZoomMap
};
